module.exports = __webpack_public_path__ + "assets/img/ed4d535bfcf8d4dec3b9c7f335ca7c92.png";